import React, { useEffect, useState, forwardRef } from 'react';
import { Link } from 'react-router-dom';
import '../styles/categories.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { supabase } from '../lib/supabase';

const Categories = forwardRef((props, ref) => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 800, easing: 'ease-in-out', once: true });

        const fetchCategories = async () => {
            try {
                const { data: categoryData, error } = await supabase
                    .from('categories')
                    .select('*')
                    .order('id');

                if (error) throw error;

                // Map through each category and assign placeholder icons
                const updatedCategories = categoryData.map((category, index) => ({
                    id: category.id,
                    name: category.name,
                    description: category.description,
                    slug: category.slug, // Ensuring the slug is passed for navigation
                    // Cycle through the 9 available icons so any number of categories renders.
                    // (Previously required icon${index+1}.png, which threw once there were >9
                    // categories and left the homepage with no categories at all.)
                    icon: require(`../assets/icons/icon${(index % 9) + 1}.png`)
                }));

                setCategories(updatedCategories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, []);

    return (
        <section className="categories-section" ref={ref}>
            <h2 className="categories-title">Explore Our Categories</h2>
            <div className="categories-container">
                {categories.map((category) => (
                    <Link
                        to={`/category/${category.slug}`} // Navigate to the category page
                        key={category.id}
                        className="category-card"
                        data-aos="fade-up" // Adds the AOS animation
                     >
                        <img src={category.icon} alt={category.name} className="category-icon" />
                        <h3 className="category-title">{category.name}</h3>
                        <div className="category-description">{category.description}</div>
                    </Link>
                ))}
            </div>
        </section>
    );
});

export default Categories;
